module.exports = __webpack_public_path__ + "img/wrapper__stepper.723ac418.svg";